export const ContextAttributesEnum = {
    Eletric: 1,
};



// WEBPACK FOOTER //
// ./src/enuns/contextAttributes.enum.js